<template>
  <div class="q-checkbox" :class="{ disabled: disabled }" @click="onClick">
    <div class="icon" :id="id" :class="getIconClass()" @mouseenter="setHover(true)" @mouseout="setHover(false)"></div>
    <div class="text" v-if="label">{{label}}</div>
  </div>
</template>
<script>
export default {
  name: 'checkbox',
  props: {
    label: {
      type: String
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      hover: false
    }
  },
  methods: {
    onClick () {
      this.$log.info('receive checkbox click')
      this.$emit('update:checked', !this.checked)
    },
    getIconClass () {
      let result = null
      if (this.checked) {
        result = 'icon-check_1'
      } else {
        result = 'icon-check_0'
      }
      if (this.disabled) {
        result = result + ' disabled'
      } else {
        if (this.hover) {
          result = result + '_hover'
        }
      }
      return result
    },
    setHover (status) {
      this.hover = status
    }
  }
}
</script>
<style lang="scss">
.q-checkbox {
  position: absolute;
  display: inline-block;
  width: 20px;
  height: 20px;
  &.disabled {
    cursor: default;
  }
  >.icon {
    margin: auto;
    width: 20px;
    height: 20px;
    font-size: 20px;
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  >.text {
    display: inline-block;
    color: #2f2f2f;
    margin-left: 10px;
  }
}

.q-checkbox-label {
  position: initial;
  background-repeat: no-repeat;
  vertical-align: middle;
  text-align: center;
  .icon {
    background-size: cover;
  }
  .text {
    display: table-cell;
    color: #2f2f2f;
    margin-left: 10px;
    width: auto;
    vertical-align: middle;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/module/Checkbox.vue